import * as React from "react"
import type { SVGProps } from "react"
const SvgLinkTrigger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 8a1 1 0 0 0-1-1H7a5 5 0 1 0 0 10h3a1 1 0 1 0 0-2H7a3 3 0 1 1 0-6h3a1 1 0 0 0 1-1m3-1a1 1 0 1 0 0 2h3a3 3 0 0 1 2.9 2.25 1 1 0 0 0 1.94-.5A5 5 0 0 0 17 7zm3.5 10h-1.55a.5.5 0 0 1-.44-.26.5.5 0 0 1 .04-.51l2.5-3.58q.12-.15.29-.1t.16.25V15h1.55q.3 0 .44.26a.5.5 0 0 1-.04.52l-2.5 3.57q-.12.15-.29.1t-.16-.25z" />
    <path d="M9 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z" />
  </svg>
)
export default SvgLinkTrigger
